import type { Nullable } from "../../typescript"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function nullIfEmptyArray<T extends any[]>(value: Nullable<T>): Nullable<T> {
  if (value?.length === 0) {
    return null;
  }
  return value;
}